export default "__VITE_ASSET__CFErsqxe__"